export default function components(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },

        html: {
          height: '100%',
          width: '100%',
        },

        body: {
          height: '100%',
          width: '100%',
          margin: 0,
          padding: 0,
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
        },

        '#root': {
          height: '100%',
        },

        a: {
          textDecoration: 'none',
          color: 'inherit',
        },

        '*[dir="rtl"] .buyNowImg': {
          transform: 'scaleX(-1)',
        },

        '.border-none': {
          border: '0px',

          td: {
            border: '0px',
          },
        },

        '.btn-xs': {
          minWidth: '30px !important',
          width: '30px',
          height: '30px',
          borderRadius: '6px !important',
          padding: '0px !important',
        },

        '.hover-text-primary:hover .text-hover': {
          color: theme.palette.primary.main,
        },

        '.hoverCard:hover': {
          scale: '1.01',
          transition: '0.1s ease-in',
        },

        '.signup-bg': {
          position: 'absolute',
          top: 0,
          right: 0,
          height: '100%',
        },

        '.MuiBox-root': {
          borderRadius: theme.shape.borderRadius,
        },

        '.MuiCardHeader-action': {
          alignSelf: 'center !important',
        },

        '.emoji-picker-react .emoji-scroll-wrapper': {
          overflowX: 'hidden',
        },

        '.scrollbar-container': {
          borderRight: '0 !important',
        },

        '.theme-timeline .MuiTimelineOppositeContent-root': {
          minWidth: '90px',
        },

        '.MuiAlert-root .MuiAlert-icon': {
          color: 'inherit !important',
        },

        '.MuiTimelineConnector-root': {
          width: '1px !important',
        },

        '.simplebar-scrollbar:before': {
          background: `${theme.palette.grey[300]} !important`,
        },
      },
    },

    MuiButtonGroup: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },

    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,

          '&:before': {
            backgroundColor: theme.palette.grey[100],
          },
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: theme.palette.background.paper,
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          width: '100%',
          padding: '0px',
          backgroundImage: 'none',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '10px',
          boxShadow: '0 1px 4px rgba(6, 43, 82, 0.04)',
        },
      },
    },

    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '12px 18px',
        },

        title: {
          fontSize: '0.95rem',
          fontWeight: 600,
          color: theme.palette.text.primary,
        },
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '22px 24px !important',
          [theme.breakpoints.down('lg')]: {
            padding: '16px 18px !important',
          },
          '&:last-child': {
            paddingBottom: '22px !important',
            [theme.breakpoints.down('lg')]: {
              paddingBottom: '16px !important',
            },
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '7px',
          fontWeight: 500,
          fontSize: '0.875rem',
          padding: '8px 16px',
          [theme.breakpoints.down('lg')]: {
            fontSize: '0.8125rem',
            padding: '6px 14px',
          },
          boxShadow: 'none',
          transition: 'all 0.2s ease',
        },

        containedPrimary: {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,

          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: 'none',
          },
        },

        containedSecondary: {
          '&:hover': {
            boxShadow: 'none',
          },
        },

        text: {
          padding: '4px 10px',
        },

        textPrimary: {
          backgroundColor: theme.palette.primary.light,

          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#FFFFFF',
          },
        },

        textSecondary: {
          backgroundColor: theme.palette.secondary.light,

          '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: '#FFFFFF',
          },
        },

        outlinedPrimary: {
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,

          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#FFFFFF',
          },
        },

        outlinedSecondary: {
          '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: '#FFFFFF',
          },
        },

        outlinedError: {
          '&:hover': {
            backgroundColor: theme.palette.error.main,
            color: '#FFFFFF',
          },
        },

        outlinedSuccess: {
          '&:hover': {
            backgroundColor: theme.palette.success.main,
            color: '#FFFFFF',
          },
        },

        outlinedInfo: {
          '&:hover': {
            backgroundColor: theme.palette.info.main,
            color: '#FFFFFF',
          },
        },

        outlinedWarning: {
          '&:hover': {
            backgroundColor: theme.palette.warning.main,
            color: '#FFFFFF',
          },
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          backgroundColor: theme.palette.background.paper,
          fontSize: '0.875rem',
          [theme.breakpoints.down('lg')]: {
            fontSize: '0.8125rem',
          },

          '& .MuiOutlinedInput-notchedOutline': {
            borderColor:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[200]
                : theme.palette.grey[300],
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
          },

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
            borderWidth: '1px',
          },
        },

        input: {
          padding: '10px 14px',
          [theme.breakpoints.down('lg')]: {
            padding: '8px 12px',
          },
        },

        inputSizeSmall: {
          padding: '8px 12px',
          [theme.breakpoints.down('lg')]: {
            padding: '6px 10px',
          },
        },
      },
    },

    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },

    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        select: {
          minHeight: '20px',
          fontSize: '0.875rem',
          [theme.breakpoints.down('lg')]: {
            fontSize: '0.8125rem',
          },
        },
      },
    },

    MuiTable: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          width: '100%',
          borderCollapse: 'separate',
          borderSpacing: 0,
        },
      },
    },

    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: '100%',
          maxWidth: '100%',
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'thin',
          '&::-webkit-scrollbar': {
            height: '6px',
            width: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#cbd5e1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f8fafc',
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: '12px 16px',
          fontSize: '0.875rem',
          [theme.breakpoints.down('lg')]: {
            padding: '8px 12px',
            fontSize: '0.8125rem',
          },
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          lineHeight: 1.4,
        },

        head: {
          backgroundColor: '#f8fafc',
          color: '#475569',
          fontWeight: 700,
          fontSize: '0.8rem',
          [theme.breakpoints.down('lg')]: {
            fontSize: '0.75rem',
            padding: '9px 12px',
          },
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          padding: '12px 16px',
          borderBottom: `1px solid ${theme.palette.divider}`,
        },

        body: {
          color: theme.palette.text.primary,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },

        sizeSmall: {
          padding: '8px 12px',
          fontSize: '0.8125rem',
          [theme.breakpoints.down('lg')]: {
            padding: '6px 10px',
            fontSize: '0.75rem',
          },
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
    },

    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          minHeight: '44px',
          paddingLeft: '8px',
          paddingRight: '8px',
          flexWrap: 'wrap',
        },
        selectLabel: {
          fontSize: '0.75rem',
          color: '#64748b',
        },
        displayedRows: {
          fontSize: '0.75rem',
          color: '#64748b',
        },
        menuItem: {
          fontSize: '0.8125rem',
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child td': {
            borderBottom: 0,
          },

          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.background.paper,
          borderColor: theme.palette.divider,
          borderRadius: 0,
        },
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '10px',
          boxShadow: '0 8px 24px rgba(6, 43, 82, 0.12)',
        },
      },
    },

    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[9],
        },
      },
    },

    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.25rem',
          fontWeight: 600,
          color: theme.palette.text.primary,
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '0.75rem',
          borderRadius: '6px',
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: theme.palette.background.paper,
          background: theme.palette.text.primary,
          borderRadius: '6px',
        },
      },
    },

    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },

        sizeSmall: {
          width: 30,
          height: 30,
          minHeight: 30,
        },
      },
    },

    MuiAlert: {
      styleOverrides: {
        filledSuccess: {
          color: '#FFFFFF',
        },

        filledInfo: {
          color: '#FFFFFF',
        },

        filledError: {
          color: '#FFFFFF',
        },

        filledWarning: {
          color: '#FFFFFF',
        },

        standardSuccess: {
          backgroundColor: theme.palette.success.light,
          color: theme.palette.success.main,
        },

        standardError: {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.main,
        },

        standardWarning: {
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.main,
        },

        standardInfo: {
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.main,
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[200],
          borderRadius: '6px',
        },
      },
    },

    MuiTimelineConnector: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.divider,
        },
      },
    },

    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
        },
      },
    },
  };
}